var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-actions"},[_c('a',{staticClass:"button is-white has-text-weight-bold",on:{"click":function($event){return _vm.itemAction(_vm.rowData.uuid)}}},[_vm._v("Details")])])
}
var staticRenderFns = []

export { render, staticRenderFns }